module.exports = __webpack_public_path__ + "static/media/interserve-logo.30aa76e6.svg";